import { baseShadowStyle } from '@shared/style/base-shadow';
import { COLORS } from '@shared/config/colors/colors';
import { styled } from 'goober';

export const Controls = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
    height: fit-content;
    visibility: hidden;
    opacity: 0;
    transition: 0.3s opacity;
`;

export const Wrapper = styled('div')`
    position: relative;
    display: flex;
    align-items: center;
    padding: 20px;
    gap: 20px;
    border-radius: 20px;
    border: 1px solid ${COLORS.neutral_05};
    ${baseShadowStyle}

    &:hover {
        border: 1px solid ${COLORS.primary_50};
    }

    &:hover ${Controls} {
        visibility: visible;
        opacity: 1;
    }
`;

export const InfoGroup = styled('div')<{ $maxWidth?: number }>(({ $maxWidth }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
    maxWidth: $maxWidth ? `${$maxWidth}px` : 'unset',
}));
